var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bufferValue),expression:"bufferValue"}],staticClass:"form-control outline-secondary",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.bufferValue)},on:{"input":function($event){if($event.target.composing)return;_vm.bufferValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }